import { render, staticRenderFns } from "./user_kjcx.vue?vue&type=template&id=4bc3e9ea&"
import script from "./user_kjcx.vue?vue&type=script&lang=js&"
export * from "./user_kjcx.vue?vue&type=script&lang=js&"
import style0 from "./user_kjcx.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!E:\\vue_project\\odoo14_chaxin_qzkj_vue\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports